import React, { useState, useEffect, useContext } from "react";
import { Button, List, Modal, Popover, Row } from "antd";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import { startPaymentProcess } from "./utils";
import { SignedInDoctor } from "../auth/interfaces";
import { SignedInContext } from "../AppEnv";

const business = [
  {
    icon: <CheckCircleOutlined className="green-icon" rev={undefined} />,
    title: "Infiniti Pazienti",
    description: "Sarà possibile creare pazienti senza alcun limite.",
  },
  {
    icon: <CheckCircleOutlined className="green-icon" rev={undefined} />,
    title: "Infiniti Dottori",
    description: "Sarà possibile creare dottori senza alcun limite.",
  },
  {
    icon: <ExclamationCircleOutlined className="yellow-icon" rev={undefined} />,
    title: "512Mb Storage",
    description: "A disposizione soli 512Mb di Archiviazione Foto.",
  },
  {
    icon: <CheckCircleOutlined className="green-icon" rev={undefined} />,
    title: "Tutti gli Esami Posturali",
    description: "Sarà possibile utilizzare tutti gli esami posturali.",
  },
  {
    icon: <ExclamationCircleOutlined className="yellow-icon" rev={undefined} />,
    title: "Alcuni esami Neurologici",
    description: "Sarà possibile utilizzare alcuni degli esami neurologici.",
  },
  {
    icon: <ExclamationCircleOutlined className="yellow-icon" rev={undefined} />,
    title: "Supporto dell' AI Limitata",
    description: "Sarà possibile creare report di testo limitato con AI.",
  },
  {
    icon: <CheckCircleOutlined className="green-icon" rev={undefined} />,
    title: "Logo Personalizzato",
    description:
      "Sarà possibile personalizzare tutti i referti con il proprio logo.",
  },
  {
    icon: <CheckCircleOutlined className="green-icon" rev={undefined} />,
    title: "Creazione PDF",
    description: "Sarà possibile creare report in formato PDF.",
  },
  {
    icon: <ExclamationCircleOutlined className="yellow-icon" rev={undefined} />,
    title: "Assistenza",
    description: "Assistenza Business, accesso all'assistenza entro 24h/48h.",
  },
  {
    icon: <CloseCircleOutlined className="red-icon" rev={undefined} />,
    title: "Backup",
    description: "Non sarà possibile richiedere un backup da scaricare.",
  },
];

// Dichiarazione di tipo per window.paypal
declare global {
  interface Window {
    paypal: any;
  }
}

const PriceBusiness: React.FC = () => {
  const [error, setError] = useState<string | null>(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const signedInDoctor: SignedInDoctor =
    useContext(SignedInContext).signedInDoctor;

  const buySubscription = async () => {
    const paymentStartResp = await startPaymentProcess(signedInDoctor, 0);
    console.log(paymentStartResp);

    if (paymentStartResp.error) {
      setError(paymentStartResp.error);
    } else window.location.href = paymentStartResp.url;
  };

  /*
  //Old payment method
  const showModal = () => {
    setIsModalVisible(true);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
  };

  useEffect(() => {
    if (isModalVisible) {
      const script = document.createElement("script");
      script.src =
        "https://www.paypal.com/sdk/js?client-id=AftFaqh1lTBMnK79zaNt8lYwfLyhh8MJkRtZFThAdFnqpKbhc4h7oEUZxnoe-DsIXGGQ9ta0j41Zt0OS&vault=true&intent=subscription";
      script.async = true;
      script.onload = () => {
        if (window.paypal) {
          window.paypal
            .Buttons({
              style: {
                shape: "pill",
                color: "blue",
                layout: "vertical",
                label: "subscribe",
              },
              createSubscription: function (data: any, actions: any) {
                return actions.subscription.create({
                  plan_id: "P-4K97141247706391UM2YP2KY", // Assicurati di usare il tuo plan_id
                });
              },
              onApprove: function (data: any, actions: any) {
                alert(data.subscriptionID); // Puoi aggiungere un messaggio di successo opzionale per l'abbonato qui
              },
            })
            .render("#paypal-button-container");
        }
      };
      document.body.appendChild(script);
    }
  }, [isModalVisible]);
  */

  return (
    <>
      <div className="cardos">
        <h2 className="lol13">Business</h2>
        <div className="cardosy">
          <Row className="downly">
            <h2 className="lol1">399</h2>
            <h2 className="lol3">,99</h2>
            <h2 className="lol2">/</h2>
            <h2 className="lol3">Anno</h2>
          </Row>
          <div className="spacedde"></div>

          <List
            itemLayout="horizontal"
            dataSource={business}
            renderItem={(item) => (
              <List.Item>
                <List.Item.Meta
                  avatar={item.icon}
                  title={
                    <Popover title={item.description}>{item.title}</Popover>
                  }
                />
              </List.Item>
            )}
          />
          <div className="buybt">
            <Row></Row>
            <Button className="buybtn" onClick={buySubscription}>
              Abbonati
            </Button>
            {error && <div className="error-message">{error}</div>}
          </div>
        </div>
      </div>

      {/* <Modal
        title="Abbonati a Licenza Business"
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={null}
      >
        <div style={{ margin: "75px" }} id="paypal-button-container"></div>
      </Modal>
      */}
    </>
  );
};

export default PriceBusiness;
